import styled, { css, keyframes } from 'styled-components';
import { prop } from 'ramda';

import { styleWhenTrue } from '../../utils/render.utils';
import { Media } from '../../theme/media.constant';
import { Color } from '../../theme/color.constant';

import { ClearIconData } from "./searchBox.types";

export const Input = styled.input`
  width: 170px;
`;

export const InputContainer = styled.div`
  position: relative;
  height: 54px;
  border-radius: 50px;
  border: 1px solid ${Color.veryLightGrey};
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  transition: width 0.5s;
  padding: 0 20px;
  align-items: center;
  width: 230px;
  border-radius: 27px;
  ${Media.tablet`
    width: 230px; 
  `}
`;

export const ClearIcon = styled.img<ClearIconData>`
  height: 7px;
  cursor: pointer;
`;
export const Form = styled.form``;

export const SearchIcon = styled.img`
  width: 22px;
  z-index: 20;
  cursor: pointer;
`;
